import { Color, HorizontalFlex, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const RecordingListNoResultContainer = styled(HorizontalFlex)`
  color: ${Color.Teal.V30};
  flex-direction: column !important;
  gap: ${Space.V24};
  margin-top: ${Space.V72};

  .primaryMessage {
    color: ${Color.Neutral.V70};
  }
  .secondaryMessage {
    color: ${Color.Neutral.V60};
  }
`;
